import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './TableRow.css';

export interface ITableRowProps {
  fullWidth?: boolean;
  hover?: boolean;
  ref?: React.Ref<HTMLTableRowElement>;
}

export function TableRowComponent({
  children,
  hover,
  ref,
}: React.PropsWithChildren<ITableRowProps>): React.JSX.Element {
  return (
    <tr ref={ref} className={clsx(style['row'], hover && style['row--hovered'])}>
      {children}
    </tr>
  );
}

export const TableRow = React.memo(TableRowComponent);
